import React from "react";
import CmsBlock from "app/layout/cmsBlock";

export const LeadingTheWayImage = () => {
  return <CmsBlock id={"leading_the_way_image_v2"} />;
};

export const LeadingTheWayText = () => {
  return <CmsBlock id={"leading_the_way_text_v2"} />;
};
